
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import numeral from 'numeral';

export default function TourDescription(props) {
    const { tour } = props.data

    return (
        <div>
            <div className="text-uppercase">
                {tour.name}
            </div>


            <div>
                {
                    !_.isEmpty(tour.short_description) &&
                    <div className="mb-3">
                        <span className="font-weight-bold font-large" dangerouslySetInnerHTML={{ __html: tour.short_description }} />
                    </div>
                }

                {
                    !_.isEmpty(tour.overview) &&
                    <div dangerouslySetInnerHTML={{ __html: tour.overview }} />
                }
            </div>


            <div>
                <div>
                    <span className="text-uppercase body-font font-weight-bold">Starting from</span>
                    <span className="body-text-color mx-2">US {numeral(tour.price).format('$0,0.0')} pp</span>
                </div>


                {
                    !_.isEmpty(tour.date_settings) &&
                    !_.isEmpty(tour.date_settings.duration) &&
                    <div className="body-text-color font-small"><i className="far fa-clock mr-1"></i><span className="font-small">{tour.date_settings.duration}</span></div>
                }
            </div>
        </div>
    )
}


const container = document.getElementById('tour-description-w')
if (container) {
    const data = Object.assign({}, container.dataset);

    ReactDOM.render(<TourDescription data={JSON.parse(data.data)} />, container);
}


// WEBPACK FOOTER //
// ./resources/js/components/Shortcodes/TourDescription.jsx